import { render, staticRenderFns } from "./Polls.vue?vue&type=template&id=3f0c3d8f&scoped=true"
import script from "./Polls.vue?vue&type=script&lang=js"
export * from "./Polls.vue?vue&type=script&lang=js"
import style0 from "./Polls.vue?vue&type=style&index=0&id=3f0c3d8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0c3d8f",
  null
  
)

export default component.exports